import { observer } from 'mobx-react';
import * as React from 'react';
import { ProgramDetailResource } from '../../ProgramStore/Types';
import LearningPartnersRenderer from './LearningPartnersRenderer';

interface Props {
  programDetailResource: ProgramDetailResource;
}

class LearningPartnersSummary extends React.Component<Props> {
  render() {
    const { programDetailResource } = this.props;
    return <LearningPartnersRenderer programDetailResource={programDetailResource} />;
  }
}

export default observer(LearningPartnersSummary);
